export default {
  posts: [],
  tag: null,
  tags: [],
  tagsPosts: [],
  post: null,
  total: null,
  next: null,
  paginate: 30,
  fetching: true,
};
